var isNumber = require('./isNumber')

/* eslint-disable eqeqeq */
function isNumberNaN (obj) {
  return isNumber(obj) && isNaN(obj)
}

module.exports = isNumberNaN



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/isNaN.js
// module id = 525
// module chunks = 98